import { heatRanking, heroImage, liveStats } from "@/mocks/homeData";

const keywordChips = ["蝌蚪黑料热议", "蝌蚪黑料舆论发酵", "蝌蚪黑料评论区", "蝌蚪黑料网友评论"];

export default function HeroSection() {
  return (
    <section className="border-b border-background-300/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1">
              <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500" />
              <span className="font-label text-xs tracking-wide text-primary-700">
                实时围观 · 舆论发酵持续追踪中
              </span>
            </div>

            <h2 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-[42px] md:leading-[1.18]">
              蝌蚪黑料热议一屏看全，
              <br className="hidden md:block" />
              跟着舆论发酵的节奏，理清争议的来龙去脉
            </h2>

            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              这里是蝌蚪黑料的单页围观台：把正在发酵的话题、短讯、大图卡片流与
              蝌蚪黑料评论区里最有信息量的网友评论，按时间线集中摆在一起。不急着下结论，先把材料对齐，
              再判断当下的吃瓜风向到底往哪边走。
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              {keywordChips.map((chip) => (
                <span
                  key={chip}
                  className="cursor-pointer whitespace-nowrap rounded-md border border-accent-300 bg-accent-100 px-3 py-1.5 font-label text-xs text-accent-900 transition-colors hover:bg-accent-200"
                >
                  #{chip}
                </span>
              ))}
            </div>

            <div className="mt-7 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
              {liveStats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-300/70 bg-background-100 p-3 md:p-4"
                >
                  <p className="font-label text-xs text-foreground-500">{stat.label}</p>
                  <p className="mt-2 flex items-baseline gap-1">
                    <span className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                      {stat.value}
                    </span>
                    <span className="font-label text-xs text-foreground-500">{stat.unit}</span>
                  </p>
                  <p className="mt-1 font-label text-xs text-secondary-600">{stat.trend}</p>
                </div>
              ))}
            </div>
          </div>

          <aside className="rounded-lg border border-background-300/70 bg-background-100 p-4 md:p-5">
            <div className="relative h-32 w-full overflow-hidden rounded-md md:h-36">
              <img
                src={heroImage}
                alt="蝌蚪黑料热议与舆论发酵话题的抽象插画"
                title="蝌蚪黑料热议话题热度追踪"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <div className="mt-4 flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">实时热度榜</h3>
              <span className="flex items-center gap-1 font-label text-xs text-foreground-500">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-refresh-line text-xs"></i>
                </span>
                每分钟刷新
              </span>
            </div>

            <ul className="mt-3 space-y-3">
              {heatRanking.map((item) => (
                <li key={item.id}>
                  <div className="flex items-start gap-2">
                    <span
                      className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded font-label text-xs font-bold ${
                        item.id === 1
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      {item.id}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate font-label text-sm text-foreground-900">{item.title}</p>
                      <div className="mt-1.5 flex items-center gap-2">
                        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-300">
                          <div
                            className="heat-bar h-full rounded-full bg-accent-500"
                            style={{ width: `${Math.round((item.heat / 9820) * 100)}%` }}
                          />
                        </div>
                        <span className="font-label text-xs text-foreground-500">{item.heat}</span>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}